import { PagedResult } from '../../core/models/paged-result.model';

/**
 * Ignite table data types
 */
export interface UkgTableData {
  data: Record<string, string | CellObject>;
  selected?: boolean;
  index?: number;
}

export interface CellObject {
  component: string;
  props?: Record<string, unknown>;
  text?: string;
  sortValue?: string | number | boolean;
}

export type ColumnData = Record<string, ColumnObject | string>;

export interface ColumnObject {
  label: string;
  disabled?: boolean;
  align?: string;
  sticky?: string;
  locked?: boolean;
  visible?: boolean;
  sorted?: 'asc' | 'desc' | 'none';
}

/**
 * Transform paged result to UkgTableData format
 * Returns empty array if pagedResult is null/undefined or has no items
 */
export function transformToTableData<T>(
  pagedResult: PagedResult<T> | null,
  transformer: (item: T, index: number) => Record<string, string>
): UkgTableData[] {
  if (!pagedResult?.items) return [];

  return pagedResult.items.map((item, index) => ({
    data: transformer(item, index),
    selected: false,
    index,
  }));
}

/**
 * Safe fallback for null/undefined values
 * Uses nullish coalescing to return fallback only for null/undefined
 */
export function nullishFallback(
  value: string | null | undefined,
  fallback = '-'
): string {
  return value ?? fallback;
}
